<template>
  <transition name="modal">
    <div class="modal__mask" v-if="showModal">
      <div class="modal__wrapper">
        <div class="modal__container modal-posicao">
          <div class="content__modal">
            <button class="close__modal" @click="closeModal">
              <i class="fas fa-times"></i>
            </button>

            <div class="inner__modal">
              <h2>Posição PAS</h2>
              <div class="conteudo-tabela">
                <table class="table-modal">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nome Produto</th>
                      <th>Tipo</th>
                      <th>Qtd Bloqueada</th>
                      <th>Qtd Total</th>
                      <th>Valor Bruto</th>
                      <th>Valor IR</th>
                      <th>Valor IOF</th>
                      <th>Valor Líquido</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in listaPosicao" :key="item.IdProdutoPAS">
                      <td>{{ item.IdProdutoPAS }}</td>
                      <td>{{ item.NmProduto }}</td>
                      <td>{{ item.Tipo }}</td>
                      <td>{{ formatNumber(item.QtdBloqueada) }}</td>
                      <td>{{ formatNumber(item.QtdTotal) }}</td>
                      <td>{{ formatCurrency(item.ValorBruto) }}</td>
                      <td>{{ formatCurrency(item.ValorIR) }}</td>
                      <td>{{ formatCurrency(item.ValorIOF) }}</td>
                      <td>{{ formatCurrency(item.ValorLiquido) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="button-row">
                <button class="btnDefault" @click="closeModal">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      showModal: "GET_MODAL_VISUALIZAR_POSICAO",
    }),
  },
  data() {
    return {
      listaPosicao: [
        {
          IdProdutoPAS: 1001,
          NmProduto: "Fundo de Investimento XYZ",
          Tipo: "Fundo de Investimento",
          QtdBloqueada: 100.5,
          QtdTotal: 1500.75,
          ValorBruto: 150000.0,
          ValorIR: 2250.0,
          ValorIOF: 150.0,
          ValorLiquido: 147600.0,
        },
        {
          IdProdutoPAS: 1002,
          NmProduto: "Fundo de Renda Fixa ABC",
          Tipo: "Fundo de Renda Fixa",
          QtdBloqueada: 0.0,
          QtdTotal: 2500.0,
          ValorBruto: 250000.0,
          ValorIR: 3750.0,
          ValorIOF: 250.0,
          ValorLiquido: 246000.0,
        },
        {
          IdProdutoPAS: 1003,
          NmProduto: "Fundo Multimercado DEF",
          Tipo: "Fundo Multimercado",
          QtdBloqueada: 50.25,
          QtdTotal: 800.0,
          ValorBruto: 80000.0,
          ValorIR: 1200.0,
          ValorIOF: 80.0,
          ValorLiquido: 78720.0,
        },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$store.commit("SET_MODAL_VISUALIZAR_POSICAO", false);
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    formatNumber(value) {
      return new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");
</style>
